import { useEffect } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { ResultsCard } from 'libs/searchspring/components/ResultCard'
import { useSearchImage } from '../../hooks/useSearchImage'
import { generateSrcSet, getLowQualityPlaceholder } from '../ResultImage'

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function QuickSearchResults() {
  const { results } = useSearchspringContext()
  const redirect = results?.merchandising?.redirect
  const { resourceImage } = useSearchImage(redirect)
  let redirectTitle = ''
  const hasProducts = results?.results?.length > 0

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [resourceImage])

  if (results?.results?.length === 0 && !redirect) return null

  if (redirect) {
    redirectTitle = redirect.split('/').pop().split('-')
    redirectTitle = redirectTitle.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  }

  return (
    <div className="grid h-fit w-full grid-cols-2 gap-gutter md:grid-cols-3 lg:grid-cols-4 md-max:w-full-margin md-max:-ml-margin">
      {redirect ? (
        <>
          <a href={redirect} className="group/card flex w-full flex-col gap-y-1" aria-label={redirectTitle}>
            <div className="overflow-hidden relative flex aspect-3/4 w-full items-center justify-center bg-neutral-medium children:size-full children:transform children:object-cover children:transition-all children:group-hover/card:scale-[1.025]">
              {resourceImage ? (
                <img
                  className="lazy size-full object-cover"
                  src={getLowQualityPlaceholder(resourceImage)}
                  data-src={resourceImage}
                  data-srcset={generateSrcSet(resourceImage, IMAGE_WIDTHS)}
                  data-sizes="50vw"
                  alt={redirectTitle}
                />
              ) : (
                <div className={'block size-full children:size-full children:object-contain'}>
                  <PageIcon />
                </div>
              )}
            </div>
            <div className="flex flex-col gap-y-0.75">
              <div className="flex flex-col gap-y-0.25">
                <p className="h6 font-medium">{redirectTitle}</p>
              </div>
              <div className="w-fit btn btn-text btn-primary btn-m group-hover/card:opacity-50">View Page</div>
            </div>
          </a>
          {hasProducts &&
            results?.results?.map((result, index) => (
              <ResultsCard
                key={result.handle}
                result={result}
                className={`w-full ${index >= 3 ? 'md:!hidden lg:!flex' : ''}`}
                dataIndex={index.toString()}
              />
            ))}
        </>
      ) : (
        results?.results?.map((result, index) => (
          <ResultsCard
            key={result.handle}
            result={result}
            className={`w-full ${index >= 3 ? 'md:!hidden lg:!flex' : ''}`}
            dataIndex={index.toString()}
          />
        ))
      )}
    </div>
  )
}

const PageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">
    <path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z" />
    <path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z" />
    <path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z" />
  </svg>
)
